import React from "react";
import { motion } from "framer-motion";
import Portada from "../../Libro.jpeg";

const FeaturedArtwork = () => {
  return (
    <section
      id="stories"
      className="py-20 bg-primary-darker relative overflow-hidden"
    >
      <motion.div
        className="absolute top-0 left-0 w-full h-96 opacity-30"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 0.3 }}
        transition={{ duration: 1.5 }}
        viewport={{ once: true }}
      >
        <div
          className="absolute inset-0 bg-no-repeat bg-cover bg-center blur-2xl"
          style={{
            backgroundImage: `url(${Portada})`,
          }}
        ></div>
      </motion.div>

      <div className="container mx-auto px-4 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="mb-12 text-center"
        >
          <h2 className="text-4xl md:text-5xl font-bold mb-4 text-accent-light">
            Libro Veintitrés hilos
          </h2>
          <p className="text-lg text-accent-light text-opacity-80 max-w-2xl mx-auto">
            Al escribir nació mi libro “Veintitrés hilos” y al sentir nacieron
            las imágenes.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-5 gap-8 items-center">
          <div className="lg:col-span-3">
            <motion.div
              initial={{ opacity: 0, scale: 0.95 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
              className="rounded-2xl overflow-hidden shadow-2xl max-w-md mx-auto"
            >
              <img
                src={Portada}
                alt="Resonancia Onírica"
                className="w-full h-auto"
              />
            </motion.div>
          </div>

          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            viewport={{ once: true }}
            className="lg:col-span-2 bg-primary-light p-8 rounded-2xl border border-accent border-opacity-20"
          >
            <div className="space-y-6">
              <div>
                <h3 className="text-lg font-semibold text-accent">
                  Sobre EL LIBRO
                </h3>
                <p className="mt-3 text-accent-light text-opacity-80">
                  Veintitrés hilos son veintitrés relatos con hilos en común.
                  Entre las historias se cuelan puertas que llevan a lugares
                  insospechados. Corren pijamas que se escapan de su dueño, caen
                  estrellas que se desprenden del cielo, nubes que se sientan en
                  la sala y recuerdos que se desdibujan en una pared blanca.
                </p>
              </div>

              <div>
                <ul className="mt-3 space-y-2">
                  <li className="flex justify-between">
                    <span className="text-accent-light text-opacity-70">
                      Año:
                    </span>
                    <span className="text-accent-light font-medium">2025</span>
                  </li>
                </ul>
              </div>

              <div className="pt-4 border-t border-accent border-opacity-20">
                <div className="flex flex-wrap items-center justify-center">
                  <motion.a
                    href="https://www.amazon.com.mx"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="bg-accent hover:bg-accent-light text-primary-dark py-3 px-6 rounded-lg font-semibold shadow-lg transition duration-300 "
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                  >
                    Comprar en Amazon
                  </motion.a>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default FeaturedArtwork;
